import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private dataToShare: any;
  private dataToShareArray: any;

  setData(data: any) {
    this.dataToShare = data;
  }

  setDataArray(dataArray: any) {
    this.dataToShareArray = dataArray;
  }

  getData() {
    return this.dataToShare;
  }

  getDataArray(){
    return this.dataToShareArray;
  }
}
